function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function generateSrcset(imageObjectOrString, widths = []) {
  let imageUrl, maxWidth;
  if (typeof imageObjectOrString === 'string') {
    imageUrl = new URL(imageObjectOrString.startsWith("//") ? `https:${imageObjectOrString}` : imageObjectOrString);
    maxWidth = parseInt(imageUrl.searchParams.get('width'));
  } else {
    if (imageObjectOrString['src'].includes('https:')) {
      imageUrl = new URL(imageObjectOrString['src']);
    } else {
      imageUrl = new URL(`https:${imageObjectOrString['src']}`);
    }
    maxWidth = imageObjectOrString['width'];
  }
  return widths.filter((width) => width <= maxWidth).map((width) => {
    imageUrl.searchParams.set('width', width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

function createMediaImg(media, widths = [], attributes = {}) {
  const image = new Image(media['width'], media['height']);
  let featuredMediaUrl;
  if (media['src'].includes('https:')) {
    featuredMediaUrl = new URL(media['src']);
  } else {
    featuredMediaUrl = new URL(`https:${media['src']}`);
  }
  for (const attributeKey in attributes) {
    image.setAttribute(attributeKey, attributes[attributeKey]);
  }
  image.alt = media['alt'] || '';
  image.src = featuredMediaUrl.href;
  image.srcset = generateSrcset(media, widths);
  return image;
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}

function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement('span');
    element.className = 'modal-scrollbar-measure', document.body.appendChild(element);

    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.Currency = (function () {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 10);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 500) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    const scrollbarWidth = window.innerWidth - document.body.offsetWidth;
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');    
    document.body.style.paddingRight = scrollbarWidth + 'px';
    document.querySelector('header').style.paddingRight = scrollbarWidth + 'px';
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    document.body.style.paddingRight = 0;
    document.querySelector('header').style.paddingRight = 0;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

const scrollbarWidth = window.innerWidth - document.body.offsetWidth;
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.classList.add('show-modal');        
    document.body.style.paddingRight = scrollbarWidth + 'px';
    document.querySelector('header').style.paddingRight = scrollbarWidth + 'px';
    if (popup) popup.loadContent();    
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    this.classList.add('hide-modal');
    setTimeout(() => {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      this.classList.remove('show-modal');
      this.classList.remove('hide-modal');
      document.body.style.paddingRight = 0;
      document.querySelector('header').style.paddingRight = 0;
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }, 500)
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    let deferredElement = this.querySelector('video, model-viewer, iframe');
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
    if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
      // force autoplay for safari
      deferredElement.play();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.mediaGallery = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
    this.frequentlyBought = document.querySelector('frequently-bought');
    this.addEventListener('change', this.onVariantChange);
    if (this.mediaGallery && customElements.get('product-gallery-component') && this.mediaGallery.dataset.gallerySynced == 'true') {
      this.variantSelects = document.querySelector(`[id^="variant-selects-${this.dataset.section}"]`);
      const galleryInstance = this.mediaGallery.getGalleryInstance();
      const gallery = this.mediaGallery.querySelector('[data-product-gallery]');
      galleryInstance.on('slideChangeTransitionEnd', () => {
        const activeItem = gallery.querySelectorAll('[data-carousel-item]')[galleryInstance.activeIndex];
        this.onMediaChange(activeItem.dataset.carouselItem);
      });
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton('', true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton('', true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    if (this.frequentlyBought) this.updateFrequentlyBought();
  }

  onCurrentVariantChange(currentVariant) {
    this.currentVariant = currentVariant;
    this.variantSelects = document.querySelector(`[id^="variant-selects-${this.dataset.section}"]`);
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.toggleAddButton('', true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton('', true, '', true);
      this.setUnavailable();
    } else {
      this.updateOptionsMedia();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  onMediaChange(mediaID) {
    this.updateMasterIdMedia(mediaID);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (this.currentVariant) {
      this.toggleAddButton('', true, '', false);
      this.updateOptionsMedia();
      this.updateVariantStatuses();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    const items = Array.from(this.querySelectorAll('.product-form__input'));
    this.options = items.map((item) => {
      const type = item.dataset.type;
      let value = '';
      const label = item.querySelector('[data-variant-value]');
      if (type === 'block') {
        value = Array.from(item.querySelectorAll('input')).find((radio) => radio.checked).value;
      } else {
        value = item.querySelector('select').value;
      }
      if (label) label.innerHTML = value;
      return value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateOptionsMedia() {
    this.currentVariant.options.forEach((option, index) => {
      if (this.variantSelects.querySelector(`input[value='${option}']`)) {
        this.variantSelects.querySelector(`[value='${option}']`).checked = true;
      } else if (this.variantSelects.querySelector(`select#Option-${this.dataset.section}-${index}`)) {
        this.variantSelects.querySelector(`select#Option-${this.dataset.section}-${index}`).value = option;
      }
      if (this.variantSelects.querySelector(`#Label-${this.dataset.section}-${index}`)) {
        this.variantSelects.querySelector(`#Label-${this.dataset.section}-${index}`).innerHTML = option;
      }
    });
  }

  updateMasterIdMedia(mediaID) {
    this.currentVariant = this.getVariantData().find((variant) => {
      if (variant.featured_media) {
        return variant.featured_media.id.toString() === mediaID;
      }
    });
  }

  updateMedia() {
    if (!this.mediaGallery || !this.currentVariant || !this.currentVariant.featured_media) return;
    if (this.mediaGallery.dataset.galleryUpdate == 'true') return;
    if (this.mediaGallery.dataset.galleryLayout != 'slider' && this.mediaGallery.dataset.galleryLayoutMobile == 'default') {
      this.mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    } else {
      const index = this.mediaGallery.querySelector(`[data-carousel-item='${this.currentVariant.featured_media.id}']`).dataset.swiperSlideIndex;
      this.mediaGallery.setActiveMediaSlider(index);
    }

    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // if (!modalContent) return;
    // const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      if (option.dataset.type === 'block') {
        this.setInputAvailabilityBlock(optionInputs, availableOptionInputsValue);
      } else {
        this.setInputAvailabilityDropdown(optionInputs, availableOptionInputsValue);
      }
    });
  }

  setInputAvailabilityDropdown(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  setInputAvailabilityBlock(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const mediaSource = html.getElementById(
          `MediaGallery-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (mediaSource && this.mediaGallery && this.mediaGallery.dataset.galleryUpdate == 'true') {
          this.mediaGallery.innerHTML = mediaSource.innerHTML;
          this.mediaGallery.init();
        }
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          this.currentVariant.id,
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(currentVariant, disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const productFormComponent = productForm.closest('product-form');
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (productFormComponent.dataset.replace == 'true') {
        if (currentVariant != '' && currentVariant != productFormComponent.dataset.replaceVariant) {
          productFormComponent.dataset.cartIndex = productFormComponent.dataset.replaceIndex;
        } else {
          productFormComponent.dataset.cartIndex = '';
        }
        addButtonText.textContent = window.variantStrings.replace;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  updateFrequentlyBought() {
    this.cardVariants = this.frequentlyBought.querySelector('card-variants');
    if (this.currentVariant) this.cardVariants.onChange(this.currentVariant);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// class ProductBelowGallery extends HTMLElement {
//   constructor() {
//     super();
//     const template = this.querySelector('template');
//     if (!template) return;
//     this.elementDesktop = document.querySelector('[data-product-below-gallery-desktop]');
//     this.elementMobile = document.querySelector('[data-product-below-gallery-mobile]');
//     this.loadContent(template.innerHTML);
//     window.addEventListener('resize', () => {this.loadContent(template.innerHTML)});
//   }

//   loadContent(content) {
//     if (window.innerWidth > 1023 && this.elementDesktop.innerHTML === '') {
//       this.elementMobile.innerHTML = '';
//       this.elementDesktop.innerHTML = content;
//     }
//     if (window.innerWidth < 1024 && this.elementMobile.innerHTML === '') {
//       this.elementDesktop.innerHTML = '';
//       this.elementMobile.innerHTML = content;
//     }
//   }
// }

// customElements.define('product-below-gallery', ProductBelowGallery);

class ProductBelowGallery extends HTMLElement {
  constructor() {
    super();

    this.currentScrollTop = 0;

    const widthInner = document.querySelector('product-info').offsetWidth;
    console.log(widthInner);
    document.querySelector('product-info').style.width = `${widthInner}px`;

    // this.offsetHeight1 = document.querySelector('.product__info-wrapper').offsetTop;
    // this.onScroll();

    // window.addEventListener('scroll', this.onScroll.bind(this), false);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = scrollTop + window.innerHeight;
    const eleHeight = document.querySelector('[data-product-below-gallery-mobile]').offsetHeight + document.querySelector('[data-product-below-gallery-mobile]').offsetTop;
    const eleHeight1 = this.offsetHeight1 + document.querySelector('.product__info-wrapper').offsetHeight;


    console.log(window.innerHeight);
    console.log(eleHeight1);
    console.log(this.offsetHeight1);
    console.log(document.querySelector('.product__info-wrapper').offsetHeight);
    // console.log(scrollTop);
    // console.log(document.querySelector('.product__info-wrapper').offsetHeight);

    if (scrollTop > this.currentScrollTop && document.querySelector('.product__info-wrapper').style.top == '0px') {
      document.querySelector('.product__info-wrapper').style.top = '';
    }

    if (scrollTop > this.currentScrollTop && windowHeight > eleHeight1 && scrollTop < eleHeight ) {
      
      const top1 =  this.offsetHeight1 - window.innerHeight;
      // const top2 = top1 - document.querySelector('.product__media-wrapper').offsetHeight;
      // document.querySelector('[data-product-below-gallery-mobile]').style.top = `${top1}px`;
      document.querySelector('.product__info-wrapper').style.top = `${top1}px`;
    } else if (scrollTop < this.currentScrollTop) {
      console.log('22222');
      document.querySelector('.product__info-wrapper').style.top = '0px';
    }
    this.currentScrollTop = scrollTop;
  }
  // constructor() {
  //   super();
  // }

  // connectedCallback() {
  //   this.header = document.querySelector('[data-product-below-gallery-mobile]');
  //   this.currentScrollTop = 0;
  //   this.preventReveal = false;
  //   this.onScrollHandler = this.onScroll.bind(this);
  //   this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  //   this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //   window.addEventListener('scroll', this.onScrollHandler, false);

  //   this.createObserver();
  // }

  // disconnectedCallback() {
  //   this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //   window.removeEventListener('scroll', this.onScrollHandler);
  // }

  // createObserver() {
  //   let observer = new IntersectionObserver((entries, observer) => {
  //     this.headerBounds = entries[0].intersectionRect;
  //     observer.disconnect();
  //   });

  //   observer.observe(this.header);
  // }

  // onScroll() {
  //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  //   console.log(this.headerBounds);
  //   console.log(this.headerBounds.bottom);

  //   if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //     console.log('1111');
  //     // this.header.classList.add('scrolled-past-header');
  //     // if (this.preventHide) return;
  //     // requestAnimationFrame(this.hide.bind(this));
  //   } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //     console.log('2222');
  //     // this.header.classList.add('scrolled-past-header');
  //     // if (!this.preventReveal) {
  //     //   requestAnimationFrame(this.reveal.bind(this));
  //     // } else {
  //     //   window.clearTimeout(this.isScrolling);

  //     //   this.isScrolling = setTimeout(() => {
  //     //     this.preventReveal = false;
  //     //   }, 66);

  //     //   requestAnimationFrame(this.hide.bind(this));
  //     // }
  //   } else if (scrollTop <= this.headerBounds.top) {
  //     console.log('3333');
  //     // this.header.classList.remove('scrolled-past-header');
  //     // requestAnimationFrame(this.reset.bind(this));
  //   }

  //   this.currentScrollTop = scrollTop;
  // }
}

customElements.define('product-below-gallery', ProductBelowGallery);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('.product-item__content')) {
            this.removeBlock();
            this.remove();
          }

          if (html.querySelector('.product-item__content')) {
            this.querySelector('[data-recommendations-loading]').classList.remove('is-loading');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  removeBlock() {
    const parent = this.closest('.product__info-border');
    if (parent && parent.querySelectorAll('.product--block').length == 1) {
      parent.remove();
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.count = 1;
    this.listId = '';
    this.limit = parseInt(this.dataset.limit);
    this.cartCount = parseInt(this.dataset.cartCount);
    this.listProduct = this.dataset.productId.split(',');
    this.slider = this.querySelector('[data-cart-recommendations-slider]');
    this.content = this.querySelector('[data-cart-recommendations-content]');
    this.recommendations = this.closest('[data-cart-recommendations]');

    if (this.recommendations.classList.contains('loading')) return;
    this.recommendations.classList.add('loading');

    this.listProduct.forEach((id) => {
      // this.fetchRecommendedProducts(`${window.routes.product_recommendations_url}?section_id=cart-recommendations&product_id=${id}&limit=${this.limit + this.cartCount}`);
    });
  }

  fetchRecommendedProducts(url) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('[data-product-content]');

        if (recommendations && recommendations.innerHTML.trim().length) {
          recommendations.querySelectorAll('[data-product-id]').forEach((item) => {
            if (!this.listId.includes(item.dataset.productId) && this.count <= this.limit) {
              this.count++;
              this.listId += ` ${item.dataset.productId}`;
              this.content.innerHTML += item.innerHTML;
            }
            if (this.count > this.limit) {
              this.slider.init();
              this.recommendations.classList.remove('loading');
              return false;
            }
          });
        }

        if (!html.querySelector('[data-product-content]')) {
          this.recommendations.classList.add('hidden');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);

class Tabs extends HTMLElement {
  constructor() {
    super();

    this.active = this.querySelector('[data-tabs-title].active');
  }

  connectedCallback() {
    this.querySelectorAll('[data-tabs-title]').forEach((action) => {
      action.addEventListener('click', this.onActionClick.bind(this))
    });
  }

  onActionClick(event) {
    event.preventDefault();

    const currentTarget = event.currentTarget;
    const currentId = currentTarget.querySelector('a').getAttribute('href');
    const activeId = this.active.querySelector('a').getAttribute('href');
    if (this.active !== currentTarget) {
      this.active.classList.remove('active');
      this.querySelector(`${activeId}`).classList.remove('is-show');
      currentTarget.classList.add('active');
      this.querySelector(`${currentId}`).classList.add('is-show');
      this.active = currentTarget;
    }
  }
}

customElements.define('tab-component', Tabs);

class AccordionComponent extends HTMLElement {
  constructor() {
    super();

    this.multi = this.dataset.accordionMulti;
    this.active = null;
    this.prevBtn = null;
    this.querySelectorAll('[data-accordion-action]').forEach((action) => {
      action.addEventListener('click', this.onActionClick.bind(this))
    });

    this.querySelectorAll('[data-accordion]').forEach((accordion) => {
      if (accordion.dataset.expanded == 'true') this.onShow(accordion);
    });
  }

  onActionClick(event) {
    event.preventDefault();

    const currentBtn = event.currentTarget.closest('[data-accordion-heading]') || event.target;
    const panel = currentBtn.nextElementSibling;
    currentBtn.classList.toggle('active');
    if (this.multi == 'true') {
      this.onMulti(currentBtn, panel);
    } else {
      this.onOnly(currentBtn, panel);
    }

  }

  onMulti(currentBtn, panel) {
    if (currentBtn.classList.contains('active')) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      panel.style.maxHeight = null;
    }
  }

  onOnly(currentBtn, panel) {
    if (this.active) {
      this.active.style.maxHeight = null;
    }

    if (this.prevBtn && this.prevBtn !== currentBtn) {
      this.prevBtn.classList.remove('active');
    }

    if (panel !== this.active) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      this.active = panel;
      this.prevBtn = currentBtn;
    } else {
      this.active = null;
    }
  }

  onShow(accordion) {
    const panel = accordion.querySelector('[data-accordion-panel]');
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }
}

customElements.define('accordion-component', AccordionComponent);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector('[data-carousel-param]');
    this.init();
  }

  init() {
    const defaults = {
      effect: 'slide',
      direction: 'horizontal',
      autoplay: true,
      autoplaySpeed: 5,
      space: 32,
      spaceTablet: 32,
      spaceMobile: 16,
      col: 2,
      col_sm: 2,
      col_md: 3,
      col_lg: 4,
      col_xl: 5,
      col_xxl: 6,
      row: 1,
      rowMobile: 1,
      center: false,
      options: {},
    };
    // Get configuration
    const param = this.carousel.dataset.carouselParam;
    if (param === null || param === '') {
      return null;
    }
    const config = Object.assign(defaults, JSON.parse(param));
    const isNumberic = /^\d+$/;
    Object.keys(config).forEach((key) => {
      if (typeof config[key] === 'string' && isNumberic.test(config[key])) {
        config[key] = parseInt(config[key], 10);
      }
    });
    // Prepare auto play variable
    // -----------------
    let autoplay = false;
    if (config.autoplay === 'true' || config.autoplay === true) {
      autoplay = {
        delay: config.autoplaySpeed,
        disableOnInteraction: false,
      };
    }
    // Make sure the carousel has a item
    const items = this.carousel.querySelectorAll('[data-carousel-item]');
    if (items.length === 0) {
      return this;
    }
    // Check number of images for loop mode
    // ------------------------------------
    let loop = false;
    if (config.loop === 'true' || config.loop === true) {
      loop = true;
    }

    let rowMobile = config.row;
    if (config.rowMobile && config.rowMobile !== '') {
      rowMobile = config.rowMobile;
    }
    // Carousel options
    // -----------------
    const option = Object.assign({
      init: false,
      slidesPerView: config.col,
      slidesPerColumn: config.row,
      spaceBetween: config.spaceMobile,
      loop,
      direction: config.direction,
      preloadImages: false,
      centeredSlides: (config.center === 'true' || config.center === true),
      navigation: {
        nextEl: this.querySelector('[data-carousel-nav-next]'),
        prevEl: this.querySelector('[data-carousel-nav-prev]'),
      },
      pagination: {
        el: this.querySelector('[data-carousel-pagination]'),
        clickable: true,
        modifierClass: 'swiper-pagination-',
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
      },
      scrollbar: {
        el: this.querySelector('[data-carousel-scrollbar]'),
        draggable: true,
      },
      effect: config.effect,
      autoplay,
      lazy: true,
      breakpoints: {
        640: {
          slidesPerView: config.col_sm,
          slidesPerColumn: rowMobile,
        },
        768: {
          slidesPerView: config.col_md,
          spaceBetween: config.spaceTablet,
          slidesPerColumn: config.row,
        },
        1024: {
          slidesPerView: config.col_lg,
          spaceBetween: config.space,
          slidesPerColumn: config.row,
        },
        1280: {
          slidesPerView: config.col_xl,
          spaceBetween: config.space,
          slidesPerColumn: config.row,
        },
        1536: {
          slidesPerView: config.col_xxl,
          spaceBetween: config.space,
          slidesPerColumn: config.row,
        },
      },
    }, config.options);

    // Prepare container for swiper
    // ----------------------------
    const container = this.querySelector('[data-carousel-container]');
    // Get Instance from swiper
    // ------------------------
    const instance = new Swiper(container, option);
    instance.on('init', () => {
      instance.wrapperEl.classList.remove('grid');
      instance.wrapperEl.classList.remove('flex');
      // const slides = Array.from(instance.slides);
      // if (slides) {
      //   slides.forEach((slide) => {
      //     slide.classList.remove('col');
      //   });
      // }
      instance.update();
    });
    instance.init();
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const _this = this;
    const slideshow = this.querySelector('[data-index-slideshow]');
    const selectors = {
      container: '[data-slideshow-container]',
      slide: '[data-slideshow-slide]',
      background: '[data-slideshow-bkg]',
      caption: '[data-slideshow-caption]',
      captionText: '[data-slideshow-caption-text]',
      next: '[data-slideshow-nav-next]',
      prev: '[data-slideshow-nav-prev]',
      pagination: '[data-slideshow-pagination]',
      video: '[data-slideshow-video]',
    };
    const params = {
      slideshow: 'data-slideshow-param',
      caption: 'data-slideshow-caption',
      video: 'data-slideshow-video',
    };
    const timer = {};
    let instance = null;
    // Initialize slideshow
    // -------------------
    if (slideshow !== undefined) {
      // Get configuration
      const param = slideshow.dataset.slideshowParam;
      if (param === null || param === '') {
        return null;
      }
      const config = JSON.parse(param);
      // Prepare dimension
      //------------------
      this.height = parseInt(config.height, 10) || slideshow.clientHeight;
      this.width = parseInt(config.width, 10) || slideshow.clientWidth;
      // Prepare container for swiper
      // ----------------------------
      const container = slideshow.querySelector(selectors.container);
      container.style.height = `${((slideshow.offsetWidth / this.width) * this.height).toFixed(4)}px`;
      // Make sure the slideshow has a slide
      const slides = Array.from(slideshow.querySelectorAll(selectors.slide));
      if (!slides) {
        return this;
      }
      // Set Entrancing effect for captions in first slide
      // -------------------------------------
      if (slides) {
        slides.forEach((slide, index) => {
          const captions = Array.from(slide.querySelectorAll(selectors.caption));
          let delay = 50 * (captions.length - 1);
          if (captions) {
            captions.forEach((caption) => {
              const image = caption;
              const captionParam = caption.dataset.slideshowCaption;
              if (captionParam !== null && captionParam !== '') {
                const captionConfig = JSON.parse(captionParam);
                const parent = caption.parentNode;
                const css = {
                  position: 'relative',
                  'animation-delay': `${delay}ms`,
                };
                Object.keys(css).forEach((property) => {
                  caption.style[property] = css[property]; // eslint-disable-line
                });
                if (index === 0) {
                  caption.classList.add(captionConfig.entranceEffect);
                } else {
                  caption.classList.add(captionConfig.exitEffect);
                }
              }
              delay -= 50;
            });
          }
        });
      }
      // Prepare auto play variable
      // -----------------
      let autoplay = false;
      if (config.autoplay === 'true') {
        autoplay = {
          delay: parseInt(config.autoplaySpeed, 10),
          disableOnInteraction: false,
        };
      }
      // Get Instance from swiper
      // ------------------------
      instance = new Swiper(container, {
        init: false,
        slidesPerView: 1,
        loop: slides.length,
        direction: 'horizontal',
        preloadImages: false,
        navigation: {
          nextEl: slideshow.querySelector(selectors.next),
          prevEl: slideshow.querySelector(selectors.prev),
        },
        pagination: {
          el: slideshow.querySelector(selectors.pagination),
          clickable: true,
          modifierClass: 'swiper-pagination-',
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
          currentClass: 'swiper-pagination-current',
          totalClass: 'swiper-pagination-total',
          hiddenClass: 'swiper-pagination-hidden',
        },
        effect: config.effect,
        autoplay,
        lazy: {
          loadPrevNext: true,
        },
      });
      // Assign videos
      // --------------
      const player = {};
      const playerFile = {};
      instance.on('init', () => {
        const captionText = Array.from(slideshow.querySelectorAll(selectors.captionText));
        if (captionText) {
          captionText.forEach((text) => {
            text.classList.remove('hidden');
          });
        }

        const captions = Array.from(slideshow.querySelectorAll(selectors.caption));
        if (captions) {
          captions.forEach((img) => {
            img.classList.remove('hidden');
          });
        }
      });
      instance.init();
      // Slideshow captions control
      // -----------------
      // On Transition starting
      instance.on('slideChangeTransitionStart', () => {
        for (let index = 0; index < instance.slides.length; index++) {
          if (index !== instance.activeIndex) {
            const slideCaptions = Array.from(instance.slides[index].querySelectorAll(selectors.caption));
            if (slideCaptions) {
              slideCaptions.forEach((caption) => {
                const captionParam = caption.dataset.slideshowCaption;
                if (captionParam !== null && captionParam !== '') {
                  const captionConfig = JSON.parse(captionParam);
                  // Add the exit effect for all slides except current slide
                  caption.classList.remove(captionConfig.entranceEffect);
                  caption.classList.add(captionConfig.exitEffect);
                }
              });
            }
            const slideVideos = Array.from(instance.slides[index].querySelectorAll(selectors.video));
            if (slideVideos) {
              _this.pauseAllMedia(slideshow);
            }
          } else {
            if (find(selectors.background, instance.slides[index])) {
              find(selectors.background, instance.slides[index]).classList.remove('hidden');
            }
          }
        }
      });
      // On Transition end
      instance.on('slideChangeTransitionEnd', () => {
        const slideCaptions = Array.from(instance.slides[instance.activeIndex].querySelectorAll(selectors.caption));
        if (slideCaptions) {
          slideCaptions.forEach((caption, index) => {
            const captionParam = caption.dataset.slideshowCaption;
            const captionIndex = `${instance.activeIndex}-${index}`;
            if (captionParam !== null && captionParam !== '') {
              const captionConfig = JSON.parse(captionParam);
              // Add the entrancing effect to current slide
              caption.classList.remove(captionConfig.exitEffect);
              caption.classList.add(captionConfig.entranceEffect);
              // Check exit effect timer for this slide, if it exists, clear it.
              if (timer[captionIndex] !== undefined && timer[captionIndex] !== null) {
                clearTimeout(timer[captionIndex]);
                timer[captionIndex] = null;
              }
            }
          });
        }
        // Video Youtube control
        const slideVideos = Array.from(instance.slides[instance.activeIndex].querySelectorAll(selectors.video));
        if (slideVideos.length > 0) {
          _this.playAllMedia(slideVideos[0]);
        }
        instance.update();
      });
      // Slideshow responsve control
      // ---------------------------
      // Slideshow on resize to set slideshow's height
      instance.on('resize', () => {
        container.style.height = `${((slideshow.offsetWidth / this.width) * this.height).toFixed(4)}px`;
      });
      instance.on('beforeDestroy', () => {
        removeAttr(container, 'style');
        const captions = Array.from(slideshow.querySelectorAll(selectors.caption));
        if (captions) {
          captions.forEach((caption) => {
            removeAttr(caption, 'style');
          });
        }
      });
      instance.update();
    }
  }

  pauseAllMedia($this) {
    $this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    $this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    $this.querySelectorAll('video').forEach((video) => video.pause());
  }

  playAllMedia($this) {
    $this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    });
    $this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"play"}', '*');
    });
    $this.querySelectorAll('video').forEach((video) => video.play());
  }
}

customElements.define('slideshow-component', SlideshowComponent);


class GridCollection extends HTMLElement {
  constructor() {
    super();

    this.setData();
    if (this.loadmore) {
      this.loadmore.addEventListener('click', this.onLoadMore.bind(this));
    }
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.renderSectionFromFetch(this.handle, 1, this.sectionId);
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  onScroll() {
    const scrollBottom = document.documentElement.scrollTop + document.documentElement.offsetHeight;
    if (scrollBottom > (this.offsetTop - 200)) {
      this.renderSectionFromFetch(this.handle, 1, this.sectionId);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  onLoadMore(event) {
    event.preventDefault();

    event.currentTarget.classList.add('loading');
    const paginate = event.currentTarget.dataset.loadMore;
    this.renderSectionFromFetch(this.handle, paginate, this.sectionId);
  }

  setData() {
    this.page = 1;
    this.content = this.querySelector('[data-collection-handle]');
    this.loadmoreContent = this.querySelector('[data-load-more-content]');
    this.loadmore = this.querySelector('[data-load-more]');
    this.handle = this.content.dataset.collectionHandle;
    this.sectionId = this.content.dataset.sectionId;

    this.loading = this.querySelector('[data-collection-loading]');
  }

  renderSectionFromFetch(handle, paginate, sectionId, event) {
    let url = '';
    if (handle != '') {
      url = `${handle}/?page=${paginate}&section_id=${sectionId}`;
    } else {
      url = `/?section_id=${sectionId}`;
    }
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.renderProductGrid(html.querySelector('[data-collection-content]'));
      });
  }
  renderProductGrid(html) {
    if (html) {
      const paginate = html.dataset.paginate;
      if (paginate != '') {
        this.loadmore.dataset.loadMore = paginate;
        this.page = parseInt(paginate);
      }
      this.page < 2 ? this.content.innerHTML = html.innerHTML : this.content.innerHTML += html.innerHTML;
      if (this.loadmore) {
        paginate == '' ? this.loadmoreContent.classList.add('hidden') : this.loadmore.classList.remove('loading');
      }
    }
    if (this.page < 3) this.loading.classList.remove('is-loading');
  }
}

customElements.define('collection-grid-component', GridCollection);

class ScrollTop extends HTMLElement {
  constructor() {
    super();

    this.action = this.querySelector('a');
    window.addEventListener('scroll', this.onScroll.bind(this), false);
    this.action.addEventListener('click', this.onButtonClick.bind(this));
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    scrollTop > 100 ? this.action.classList.add('is-show') : this.action.classList.remove('is-show');
  }

  onButtonClick(event) {
    event.preventDefault();

    window.setTimeout(() => { document.body.scrollIntoView({ behavior: "smooth" }); });
  }
}

customElements.define('scroll-top', ScrollTop);

class TermsConditions extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('input');
    this.checkout = document.getElementById(`ProductCheckoutButton-${this.checkbox.value}`);
    this.checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
  }

  connectedCallback() {
    if (!this.checkout) return;
  }

  onCheckboxChange() {
    const value = this.checkbox.value;
    if (this.checkbox.checked) {
      this.checkout.classList.remove('button__disabled');
    } else {
      this.checkout.classList.add('button__disabled');
    }
  }
}

customElements.define('terms-conditions', TermsConditions);

class pswpElement {
  constructor() {
    this.items = [];
    document.querySelectorAll('[data-product-media-zoom]').forEach((image, index) => {
      this.items[index] = {
        src: image.dataset.src,
        w: parseInt(image.dataset.width, 10),
        h: parseInt(image.dataset.height, 10)
      };
    });
    if (this.items.length !== 0) {
      this.gallery();
    }  
  }
  
  gallery() {
    const pswpElement = document.querySelectorAll('.pswp')[0];
    const initializeGallery = (i) => {
      const getindex = parseInt(i, 10);
      const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, this.items, {
        index: getindex,
        preload: [1, 3],
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        shareEl: false,
        history: false,
      });
      gallery.init();
    };
    document.querySelectorAll('[data-product-media-zoom]').forEach((image, index) => {
      this.items[index] = {
        src: image.dataset.src,
        w: parseInt(image.dataset.width, 10),
        h: parseInt(image.dataset.height, 10)
      };
    });
    document.querySelectorAll('[data-product-media-zoom]').forEach((el) =>
      el.addEventListener('click', (event) => {
        event.preventDefault();
        const getindex = event.currentTarget.dataset.index;
        initializeGallery(getindex);
      })
    );
  }
}

new pswpElement();

class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('[data-content]');
    this.action = this.querySelector('[data-action]');
    this.height = parseInt(this.dataset.height);
    this.heightContent = this.content.offsetHeight;
    this._updateHeight();
  }

  _updateHeight() {
    if (this.height >= this.heightContent) {
      this.content.classList.add('show');
      this.action.classList.add('hidden');
    } else {
      this.content.style.maxHeight = `${this.height}px`;
      this.readMore = this.dataset.readMore;
      this.readLess = this.dataset.readLess;
      this.action.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    if (this.action.classList.contains('read-less')) {
      this.action.classList.remove('read-less');
      this.action.innerHTML = this.readMore;
      this.content.style.maxHeight = `${this.height}px`;
    } else {
      this.action.classList.add('read-less');
      this.action.innerHTML = this.readLess;
      this.content.style.maxHeight = `${this.heightContent}px`;
    }
  }
}

customElements.define('read-more', ReadMore);

class StickyHeader {
  constructor() {
    Array.from(document.querySelectorAll('[data-sticky]')).forEach(function(element) {
      const params = element.dataset.sticky;
      if (params === null || params === '') {
        return false;
      }
      const config = JSON.parse(params);
      const stickTo = config.stickTo || 'body';
      const stickyClass = String(config.stickyClass) || 'sticky';
      const top = parseInt(config.top) || 0;
      const disableTablet = config.disableTablet || false;
      const disableMobile = config.disableMobile || false;

      new hcSticky(element, {
        stickTo: stickTo,
        stickyClass: stickyClass,
        top: top,
        responsive: {
          1023: {
            disable: disableTablet
          },
          767: {
            disable: disableMobile
          }
        }
      });
    });
  }
}

new StickyHeader();

class CardSwatches extends HTMLElement {
  constructor() {
    super();

    this.card = this.closest('[data-product-card]');
    this.link = this.card.querySelectorAll('[data-product-card-link]');
    this.input = this.querySelectorAll('input');
  }

  connectedCallback() {
    this.card.addEventListener('pointerover', () => this.onFocus(), { once: true });
    this.input.forEach((radio) => {
      radio.addEventListener('change', this.onInputChange.bind(this))
    });
  }

  onFocus = async () => {
    if (this.data) return;
    this.data = await this._getData(this.dataset.handle);
  }

  onInputChange(event) {
    event.preventDefault();

    if (!this.data) return;
    const firstVariant = this._getVariantData(event.currentTarget.value);
    if (this.link) {
      this.link.forEach((link) => {
        link.href = `${this.dataset.url}?variant=${firstVariant['id']}`;
      });
    }
    if (!firstVariant.hasOwnProperty('featured_media')) return;
    const mediaPrimary = this.card.querySelector('.product-card-media--primary');
    const mediaSecondary = this.card.querySelector('.product-card-media--secondary');
    const newMedia = this._createMediaImg(firstVariant['featured_media'], mediaPrimary.className, mediaPrimary.sizes);
    if (mediaPrimary.src != newMedia.src) {
      if (mediaSecondary) {
        const newMediaSecondary = this._createMediaImg(this.data['media'][firstVariant['featured_media']['position']] || this.data['media'][1], mediaSecondary.className, mediaSecondary.sizes);
        mediaSecondary.replaceWith(newMediaSecondary);
      }
      mediaPrimary.replaceWith(newMedia);
    }
  }

  _createMediaImg(media, className, sizes) {
    return createMediaImg(media['preview_image'], [165, 360, 533, 720, 940, 1066, media['width']], { class: className, sizes });
  }

  _getVariantData(value) {
    return this.data['variants'].find((variant) => variant[`option${this.dataset.optionPosition}`] === value);
  }

  _getData(handle) {
    const data = new Promise(async (resolve, reject) => {
      const response = await fetch(`/products/${handle}.js`);
      if (response.ok) {
        const responseAsJson = await response.json();
        resolve(responseAsJson);
      } else {
        reject(`
          Attempted to load information for product with handle ${handle}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `);
      }
    });
    return data;
  }
}

customElements.define('card-swatches', CardSwatches);

class CardVariants extends HTMLElement {
  constructor() {
    super();

    this.card = this.closest('[data-product-card]');
    this.variantSelects = document.querySelector('variant-selects');
    this.frequentlyBought = document.querySelector('frequently-bought');
    this.select = this.querySelector('select');
    this.mainProduct = this.dataset.mainProduct;
  }

  connectedCallback() {
    this.card.addEventListener('pointerover', () => this.onFocus(), { once: true });
    this.select.addEventListener('change', this.onSelectChange.bind(this));
  }

  onFocus = async () => {
    if (this.data) return;
    this.data = await this._getData(this.dataset.handle);
  }

  onSelectChange() {
    if (!this.data) return;
    const variant = this._getVariantData(this.select.value);
    if (this.mainProduct == 'true') this.variantSelects.onCurrentVariantChange(variant);
    this._changeMedia(variant);
    this._changePrice(variant);
    this.frequentlyBought.onChangePrice();
  }

  onChange(variant) {
    this.select.value = variant.id;
    this._changeMedia(variant);
    this._changePrice(variant);
    this.frequentlyBought.onChangePrice();
  }

  _changeMedia(variant) {
    if (!variant.hasOwnProperty('featured_media')) return;
    const mediaPrimary = this.card.querySelector('.product-card-media--primary');
    const newMedia = this._createMediaImg(variant['featured_media'], mediaPrimary.className, mediaPrimary.sizes);
    if (mediaPrimary.src != newMedia.src) {
      mediaPrimary.replaceWith(newMedia);
    }
  }

  _changePrice(variant) {
    const priceCard = this.card.querySelector('.price');
    const priceRegular = this.card.querySelector('.price__regular');
    const priceSale = this.card.querySelector('.price__sale');
    if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
      priceCard.classList.add('price--on-sale');
      priceSale.querySelector('.price-item--regular').innerHTML = Shopify.Currency.formatMoney(variant.compare_at_price, window.moneyFormat);
      priceSale.querySelector('.price-item--sale').innerHTML = Shopify.Currency.formatMoney(variant.price, window.moneyFormat);
    } else {
      priceCard.classList.remove('price--on-sale');
      priceRegular.querySelector('.price-item--regular').innerHTML = Shopify.Currency.formatMoney(variant.price, window.moneyFormat);
    }
  }

  _createMediaImg(media, className, sizes) {
    return createMediaImg(media['preview_image'], [165, 360, 533, 720, 940, 1066, media['width']], { class: className, sizes });
  }

  _getVariantData(value) {
    return this.data['variants'].find((variant) => variant['id'].toString() === value);
  }

  _getData(handle) {
    const data = new Promise(async (resolve, reject) => {
      const response = await fetch(`/products/${handle}.js`);
      if (response.ok) {
        const responseAsJson = await response.json();
        resolve(responseAsJson);
      } else {
        reject(`
          Attempted to load information for product with handle ${handle}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `);
      }
    });
    return data;
  }
}

customElements.define('card-variants', CardVariants);

class ProductWishlist {
  constructor() {
    this.storageKey = 'wishlist-storage';
    this._state = this._getState();
    this._onUpdateCallbacks = [];
    this._onEnableChangeCallbacks = [];
  }
  
  get products() {
    return this._state.products;
  }

  get enabled() {
    return this._state.enabled;
  }

  includes(handle) {
    return this._state.products.some(product => product.handle === handle);
  }

  runOnUpdate(fn) {
    this._onUpdateCallbacks.push(fn);
  }
  
  removeRunOnUpdate(fn) {
    this._onUpdateCallbacks = this._onUpdateCallbacks.filter(cb => cb !== fn);
  }

  add(handle) {

    this._state.products.push({
      handle
    });

    this._runUpdateCallbacks();

    this._save();
  }

  remove(handle) {
    this._state.products = this._state.products.filter(product => product.handle !== handle);
  
    this._runUpdateCallbacks();
  
    if (!this._state.products.length) {
      this._onRemoveLastProduct();
    }
  
    this._save();
  }

  removeAll() {
    this._state.products = [];
  
    this._runUpdateCallbacks();
  
    this._onRemoveLastProduct();
  
    this._save();
  }
  
  enable() {
    if (this._state.enabled) return;
    this._state.enabled = true;

    this._runEnableChangeCallbacks();

    this._save();
  }

  disable() {
    if (!this._state.enabled) return;
    this._state.enabled = false;
  
    this._runEnableChangeCallbacks();
  
    if (this._state.products.length) {
      this.removeAll();
    }
  
    this._save();
  }

  _runUpdateCallbacks() {
    const data = {
      products: this._state.products
    };
  
    this._onUpdateCallbacks.forEach(cb => cb(data));
  }

  _runEnableChangeCallbacks() {
    this._onEnableChangeCallbacks.forEach(cb => cb(this.enabled));
  }

  _onRemoveLastProduct() {
    this.disable();
  }

  _load() {
    try {
      return JSON.parse(sessionStorage.getItem(this.storageKey));
    } catch (e) {
      return null;
    }
  }

  _save() {
    sessionStorage.setItem(this.storageKey, JSON.stringify(this._state));
  }

  _getState() {
    const savedState = this._load();

    if (savedState) {
      const enabled = savedState.products.length ? savedState.enabled : false;
      return { ...savedState,
        enabled
      };
    }

    return {
      products: [],
      enabled: false
    };
  }
}


class ProductCompare {
  constructor() {
    this.storageKey = 'compare-storage';
    this._state = this._getState();
    this._onUpdateCallbacks = [];
    this._onEnableChangeCallbacks = [];
  }

  get products() {
    return this._state.products;
  }

  get atProductLimit() {
    return this._state.products.length >= 3;
  }

  get enabled() {
    return this._state.enabled;
  }

  includes(handle) {
    return this._state.products.some(product => product.handle === handle);
  }

  runOnUpdate(fn) {
    this._onUpdateCallbacks.push(fn);
  }

  removeRunOnUpdate(fn) {
    this._onUpdateCallbacks = this._onUpdateCallbacks.filter(cb => cb !== fn);
  }

  add(_ref) {
    let {
      handle,
      data
    } = _ref;

    this._state.products.push({
      handle,
      data
    });

    this._runUpdateCallbacks();

    this._save();
  }

  remove(handle) {
    this._state.products = this._state.products.filter(product => product.handle !== handle);

    this._runUpdateCallbacks();

    if (!this._state.products.length) {
      this._onRemoveLastProduct();
    }

    this._save();
  }

  removeAll() {
    this._state.products = [];

    this._runUpdateCallbacks();

    this._onRemoveLastProduct();

    this._save();
  }

  enable() {
    if (this._state.enabled) return;
    this._state.enabled = true;

    this._runEnableChangeCallbacks();

    this._save();
  }

  disable() {
    if (!this._state.enabled) return;
    this._state.enabled = false;

    this._runEnableChangeCallbacks();

    if (this._state.products.length) {
      this.removeAll();
    }

    this._save();
  }

  _runUpdateCallbacks() {
    const data = {
      products: this._state.products,
      atProductLimit: this.atProductLimit
    };

    this._onUpdateCallbacks.forEach(cb => cb(data));
  }

  _runEnableChangeCallbacks() {
    this._onEnableChangeCallbacks.forEach(cb => cb(this.enabled));
  }

  _onRemoveLastProduct() {
    this.disable();
  }

  _load() {
    try {
      return JSON.parse(sessionStorage.getItem(this.storageKey));
    } catch (e) {
      return null;
    }
  }

  _save() {
    sessionStorage.setItem(this.storageKey, JSON.stringify(this._state));
  }

  _getState() {
    const savedState = this._load();

    if (savedState) {
      const enabled = savedState.products.length ? savedState.enabled : false;
      return {
        ...savedState,
        enabled
      };
    }

    return {
      products: [],
      returnBreadcrumb: null,
      enabled: false
    };
  }
}


let tabsContainer = document.querySelector("#tabs");
let tabTogglers = tabsContainer.querySelectorAll("#tabs a");
let connectRigster = document.querySelector(".login-register");
let connectLogin = document.querySelector(".register-login");
let tab1 = document.querySelector("#tab-login");
let tab2 = document.querySelector("#tab-register");
let tab1content = document.querySelector("#drawer_login");
let tab2content = document.querySelector("#drawer_register");
tabTogglers.forEach(function (toggler) {
  toggler.addEventListener("click", function (e) {
    e.preventDefault();
    let tabName = this.getAttribute("href");
    let tabContents = document.querySelector("#tab-contents");
    for (let i = 0; i < tabContents.children.length; i++) {
      tabTogglers[i].parentElement.classList.remove("active");
      tabContents.children[i].classList.remove("hidden");
      if ("#" + tabContents.children[i].id === tabName) {
        continue;
      }
      tabContents.children[i].classList.add("hidden");
    }
    e.target.parentElement.classList.add("active");
  });
});

connectRigster.addEventListener("click", function (e) {
  e.preventDefault();
  tab1.classList.remove("active");
  tab2.classList.add("active");
  tab1content.classList.add("hidden");
  tab2content.classList.remove("hidden");
})

connectLogin.addEventListener("click", function (e) {
  e.preventDefault();
  tab1.classList.add("active");
  tab2.classList.remove("active");
  tab1content.classList.remove("hidden");
  tab2content.classList.add("hidden");
})